import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ChangeDetectorRef } from '@angular/core';
import { catchError, forkJoin, lastValueFrom, map, of } from 'rxjs';
import { CentrosMantencionService } from '../../../../services/centralization/centros-mantencion.service';
import { UsuariosService } from '../../../../services/centralization/usuarios.service';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/autocomplete';

@Component({
  selector: 'app-editar-centro',
  templateUrl: './editar-centro.component.html',
  styleUrls: ['./editar-centro.component.css'],
      standalone: true,
    imports: [
      CommonModule,
      ReactiveFormsModule,
      AutoCompleteModule
    ],
})
export class EditarCentroComponent {

  @Input() centroDatos!: any;
  @Input() sociedades: any[] = [];
  nuevoCentroForm: FormGroup;
  cantroEstadoActivacion: boolean = false;
  switchLabel: string = 'Desactivado';
  mensajeErrorCodigo: string = '';
  mensajeErrorNombre: string = '';
  suggestions: any[] = [];
  selectedItem: any;
  selectedAnalistaId: any;
  noAnalistaFound: boolean = false;
  bloquearSegmento = true;
  segmentos: any[] = [];
  sociedadSeleccionada: any = null;

  constructor(
    private readonly _formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private readonly _centrosService: CentrosMantencionService,
    private readonly _toastr: ToastrService,
    private readonly _spinner: NgxSpinnerService,
    private readonly _cdr: ChangeDetectorRef,
    private readonly _usuarioService: UsuariosService,
  ) {
    this.nuevoCentroForm = this._formBuilder.group({
      centCodigoCompania: ['', [Validators.required]],
      centNombreCentro: ['', [Validators.required]],
      centAnalistaFinanzas: ['', [Validators.required]],
      centSegmento: ['', [Validators.required]],
      //centCentroCosto: ['', [Validators.required]],
      centSociedad: ['', [Validators.required]],
      centActivado: [false],
      socId: [''],
      centIniciales: ['', [Validators.required]]

      
    });
  }

  ngOnInit(): void {
    const sociedadPreseleccionada = this.sociedades.find(
      (sociedad) => sociedad.socId === this.centroDatos.socId
    );
    if (sociedadPreseleccionada) {
      this.nuevoCentroForm.patchValue({
        centSociedad: sociedadPreseleccionada
      });
      this.segmentos = sociedadPreseleccionada.segmentos || [];
      const segmentoPreseleccionado = this.segmentos.find(
        (segmento) => segmento.seg_segmento === this.centroDatos.centSegmento
      );
      if (segmentoPreseleccionado) {
        this.nuevoCentroForm.patchValue({
          centSegmento: segmentoPreseleccionado.seg_segmento,
        });
      }
    }
    this.nuevoCentroForm.patchValue({
      centCodigoCompania: this.centroDatos.centCodigoCompania,
      centNombreCentro: this.centroDatos.centNombreCentro,
      centAnalistaFinanzas: this.centroDatos.centAnalistaFinanzas,
      centActivado: this.centroDatos.centActivado,
      socId: this.centroDatos.socId,
      centIniciales: this.centroDatos.centIniciales
    });
    this.onSwitchChange();
    this.nuevoCentroForm.get('centCodigoCompania')?.valueChanges.subscribe(() => {
      this.mensajeErrorCodigo = '';
    });
    this.nuevoCentroForm.get('centNombreCentro')?.valueChanges.subscribe(() => {
      this.mensajeErrorNombre = '';
    });
  }
  
  
  onSwitchChange() {
    this.switchLabel = this.nuevoCentroForm.controls['centActivado'].value ? 'Activado' : 'Desactivado';
  }
  search(event: any): void {
    const query = event.query;
    this._usuarioService.listarUsuariosAnalistas(query)
      .pipe(
        map((usuarios: any[]) => usuarios.filter(usuario =>
          usuario.us_nombres.toLowerCase().includes(query.toLowerCase())
        )),
        catchError(error => {
          console.error('Error al cargar los usuarios:', error);
          return of([]);
        })
      )
      .subscribe(filteredUsers => {
        this.suggestions = filteredUsers;
        this.noAnalistaFound = this.suggestions.length === 0;
        this.selectedItem = null;
      });
  }
  onAnalistaSelect(event: any) {
    console.log('event',event)
    this.selectedItem = event;
    console.log('seleccion,',this.selectedItem.value.us_nombres)
    this.nuevoCentroForm.get('centAnalistaFinanzas')?.setValue(event.value.us_nombres);
    this.noAnalistaFound = false;
  }
  

  async onSubmit() {
    if (!this.selectedItem && this.nuevoCentroForm.get('centAnalistaFinanzas')?.pristine) {
      this.selectedItem = {
        value: {
          us_id: this.centroDatos.usId,
          us_nombres: this.centroDatos.centAnalistaFinanzas,
        },
      };
    }
    if (!this.selectedItem && !this.nuevoCentroForm.get('centAnalistaFinanzas')?.pristine) {
      this._toastr.warning('Por favor, selecciona un analista válido.', 'Advertencia');
      return;
    }
    if (this.nuevoCentroForm.valid) {
      const centSociedadSeleccionada = this.nuevoCentroForm.get('centSociedad')?.value;
      const centSegmentoSeleccionado = this.nuevoCentroForm.get('centSegmento')?.value;
      const centIniciales =this.nuevoCentroForm.get('centIniciales')?.value;
      const centroEditado = {
        ...this.nuevoCentroForm.value,
        centId: this.centroDatos.centId,
        centSociedad: centSociedadSeleccionada ? centSociedadSeleccionada.socSociedad : this.centroDatos.centSociedad,
        centSegmento: centSegmentoSeleccionado ? centSegmentoSeleccionado : this.centroDatos.centSegmento,
        socId: centSociedadSeleccionada ? centSociedadSeleccionada.socId : this.centroDatos.socId,
        centUpdateAt: new Date().toISOString(),
        centActivado: this.nuevoCentroForm.value.centActivado ? 1 : 0,
        usId: this.selectedItem ? this.selectedItem.value.us_id : null,
        centAnalistaFinanzas: this.selectedItem ? this.selectedItem.value.us_nombres : null,
        centIniciales:centIniciales ? centIniciales: this.centroDatos.centIniciales
      };
      const isEqual = this.comparaCampos(centroEditado, this.centroDatos);

    if (isEqual) {
      console.log('No hubo cambios en los datos, cerrando el modal.');
      this.activeModal.close(null); // Cerrar el modal sin enviar datos
      return;
    }
      console.log('centroEditado',centroEditado)

      try {
        this._spinner.show();
        const { existeCodigo, existeNombre } = await this.verificarExistencia(
          centroEditado.centCodigoCompania,
          centroEditado.centNombreCentro
        );

        if (existeCodigo && centroEditado.centCodigoCompania !== this.centroDatos.centCodigoCompania) {
          this.mensajeErrorCodigo = 'El ID ingresado ya existe en Mantenedor de centro.';
          this._toastr.error('El ID ingresado ya existe en Mantenedor de centro.', 'Error');
        } else if (existeNombre && centroEditado.centNombreCentro !== this.centroDatos.centNombreCentro) {
          this.mensajeErrorNombre = 'El nombre ingresado ya existe en Mantenedor de centro.';
          this._toastr.error('El nombre ingresado ya existe en Mantenedor de centro.', 'Error');
        } else {
          this.activeModal.close(centroEditado);  
        }
      } catch (error) {
        console.error('Error al verificar la existencia del centro:', error);
        this._toastr.warning('Hubo un error al verificar los datos.', 'Error');
      } finally {
        this._spinner.hide();
      }
    } else {
      this._toastr.warning('Por favor, completa todos los campos requeridos.', 'Advertencia');
    }
  }

  async verificarExistencia(codigo: string, nombre: string): Promise<{ existeCodigo: boolean; existeNombre: boolean }> {
    try {
      const result = await lastValueFrom(
        forkJoin({
          existeCodigo: this._centrosService.obtenerCentroPorCodigo(codigo),
          existeNombre: this._centrosService.obtenerCentroPorNombre(nombre)
        }).pipe(
          catchError((error) => {
            console.error('Error al verificar existencia:', error);
            this._spinner.hide();
            throw error;
          })
        )
      );
  
      return result;
    } catch (error) {
      console.error('Error general:', error);
      throw error;
    }
  }
  verificarExistenciaCampo(controlName: string) {
    try {
        const valor = this.nuevoCentroForm.get(controlName)?.value;
        if (!valor) return;
        const isOriginalValue = (controlName === 'centCodigoCompania' && valor === this.centroDatos.centCodigoCompania) ||
                                (controlName === 'centNombreCentro' && valor === this.centroDatos.centNombreCentro);
        console.log('isOriginalValue', isOriginalValue);
        if (isOriginalValue) {
            if (controlName === 'centCodigoCompania') {
                this.mensajeErrorCodigo = '';
            } else if (controlName === 'centNombreCentro') {
                this.mensajeErrorNombre = '';
            }
            
            return; 
        }
        this._spinner.show();
        if (controlName === 'centCodigoCompania') {
            this._centrosService.obtenerCentroPorCodigo(valor).subscribe({
                next: (existeCodigo) => {
                    this.mensajeErrorCodigo = existeCodigo
                        ? 'El ID ingresado ya existe en Mantenedor de centro.'
                        : '';
                    this._cdr.detectChanges();
                    this._spinner.hide();
                },
                error: (error) => {
                    console.error('Error al verificar el código:', error);
                    this._spinner.hide();
                }
            });
        } else if (controlName === 'centNombreCentro') {
            this._centrosService.obtenerCentroPorNombre(valor).subscribe({
                next: (existeNombre) => {
                    this.mensajeErrorNombre = existeNombre
                        ? 'El nombre ingresado ya existe en Mantenedor de centro.'
                        : '';
                    this._cdr.detectChanges();
                    this._spinner.hide();
                },
                error: (error) => {
                    console.error('Error al verificar el nombre:', error);
                    this._spinner.hide();
                }
            });
        }
    } catch (error) {
        console.error('Error al verificar la existencia:', error);
    }
}

  salir(estado: any) {
    this.activeModal.close(estado);
  }

  validarAlfanumerico(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    let valor = input.value;
    if (controlName === 'centSegmento' || controlName === 'centCentroCosto') {
        let valorValidado = valor.replace(/[^0-9]/g, '');
        if (valorValidado.length > 10) {
            valorValidado = valorValidado.substring(0, 10);
        }
        if (valor !== valorValidado) {
            input.value = valorValidado;
            this.nuevoCentroForm.controls[controlName].setValue(valorValidado);
        }
    } else if (controlName === 'centCodigoCompania') {
      let valorValidado = valor.replace(/[^a-zA-Z0-9_-]/g, '');
        if (valorValidado.length > 10) {
            valorValidado = valorValidado.substring(0, 10);
        }
        if (valor !== valorValidado) {
            input.value = valorValidado;
            this.nuevoCentroForm.controls[controlName].setValue(valorValidado);
        }
    } else if (controlName === 'centNombreCentro' || controlName === 'centAnalistaFinanzas') {
        let valorValidado = valor.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚ ]/g, '');
        if (valorValidado.length > 30) {
            valorValidado = valorValidado.substring(0, 30);
        }
        if (valor !== valorValidado) {
            input.value = valorValidado;
            this.nuevoCentroForm.controls[controlName].setValue(valorValidado);
        }
    } else if (controlName === 'centIniciales') {
        let valorValidado = valor.replace(/[^a-zA-Z0-9]/g, '');
        if (valorValidado.length > 4) {
            valorValidado = valorValidado.substring(0, 4);
        }
        if (valor !== valorValidado) {
            input.value = valorValidado;
            this.nuevoCentroForm.controls[controlName].setValue(valorValidado);
        }
    }
}
    obtenerSociedadesYSegmentos(callback?: () => void): void {
      this._centrosService.listarSociedadesYSegmentos().subscribe({
        next: (data) => {
          console.log('Sociedades y segmentos:', data);
          this.sociedades = data; 
          console.log('this.sociedades:', this.sociedades);

          if (callback) {
            callback(); 
          }
        },
        error: (err) => {
          console.error('Error al obtener sociedades y segmentos:', err);
        },
      });
    }
    

    onSociedadChange() {
      const sociedadSeleccionada = this.nuevoCentroForm.get('centSociedad')?.value;
      if (!sociedadSeleccionada) {
        this.segmentos = [];
        this.nuevoCentroForm.get('centSegmento')?.reset();
        return;
      }
      this.segmentos = sociedadSeleccionada.segmentos || [];
      if (this.segmentos.length === 1) {
        this.nuevoCentroForm.get('centSegmento')?.setValue(this.segmentos[0].seg_segmento);
      } else {
        this.nuevoCentroForm.get('centSegmento')?.reset();
      }
    }
    
    comparaCampos(obj1: any, obj2: any): boolean {
      const fieldsToCompare = [
        'centCodigoCompania',
        'centNombreCentro',
        'centAnalistaFinanzas',
        'centSegmento',
        'centSociedad',
        'centActivado',
        'centIniciales'
      ];
      
      console.log("fieldsToCompare", fieldsToCompare);
    
      for (const field of fieldsToCompare) {
        const value1 = obj1[field] !== null && obj1[field] !== undefined ? obj1[field].toString() : '';
        const value2 = obj2[field] !== null && obj2[field] !== undefined ? obj2[field].toString() : '';
        if (value1 !== value2) {
          console.log(`Diferencia encontrada en el campo ${field}: obj1=${value1}, obj2=${value2}`);
          return false; 
        }
      }
    
      return true; 
    }
    
}